type CategoryType = { name: string, path: string }
export const getCategoryName = (categories: Array<CategoryType>) => [...categories].sort((a, b) => {
  const pathDiff = b.path.split('/').length - a.path.split('/').length
  return pathDiff || (b.name.length - a.name.length)
})[0]?.name || ''

export default getCategoryName
